import React from "react";
import Picon from "../../images/project/icon-arrow.svg";
import Picon1 from "../../images/project/icon-bg.svg";
const PortofolioCard = ({ Pimg, Psubtitle, Ptitle, Plink }) => {
  return (
    <div className="project-card">
      <div className="image">
        <img src={Pimg} alt={Ptitle} loading="lazy" />
      </div>
      <div className="content">
        <span>{Psubtitle}</span>
        <h2>{Ptitle}</h2>
        <a
          href={Plink}
          className="project-link"
          rel="noreferrer"
          aria-label={Ptitle}
        >
          <div className="icon">
            <img src={Picon} alt="icon" loading="lazy" />
          </div>
          <div className="shape">
            <img src={Picon1} alt="shape" loading="lazy" />
          </div>
        </a>
      </div>
    </div>
  );
};

export default PortofolioCard;
